import React from "react";
import LogoAndAsideTogglePart from "./LogoAndAsideToggle.part";
import { AsideHead } from "../../../components/admin/layouts/Aside/Aside";

const AsideHeadPart = () => {
  return (
    <AsideHead>
      <LogoAndAsideTogglePart />
    </AsideHead>
  );
};

export default AsideHeadPart;
